import { combineReducers } from "redux";

import sidebar from "./duckSidebar";
import filter from "./duckFilter";
import filterValue from "./duckFilterValue";
import layout from "./duckLayout";
import layoutFilter from "./duckLayoutFilter";
import menuItem from "./duckMenuItem";
import auth from "./duckAuth";
import source from "./duckSource";
import menuItemGroup from "./duckMenuItemGroup";
import filterValueGroup from "./duckFilterValueGroup";
import groups from "./duckGroups";
import tab from "./duckTab";
import filterValueFinancial from "./duckFilterValueFinancial";
import help from "./duckHelp";
import error from "./duckError";
import session from "./duckSession";
import users from "./duckUsers";
import favorites from "./duckFavorites";
import recents from "./duckRecents";
import discover from "./duckDiscover";
import audit from "./duckAudit";
import hr from "./duckHr";
import security from "./duckSecurity";
import layoutCustom from "./duckLayoutCustom";
import sidebarCollection from "./duckSidebarCollection";
import analytics from "./duckLogger";
import incident from "./duckInvgate";

export default combineReducers({
  sidebar,
  sidebarCollection,
  filter,
  filterValue,
  layout,
  layoutFilter,
  menuItem,
  auth,
  source,
  menuItemGroup,
  filterValueGroup,
  groups,
  tab,
  filterValueFinancial,
  help,
  error,
  session,
  users,
  favorites,
  recents,
  discover,
  audit,
  hr,
  security,
  layoutCustom,
  analytics,
  incident,
});
